import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackMemberAreaClick } from "@/lib/analytics";
import { memberAreaUrl } from "@/lib/memberUrl";

const NAV_LINKS = [
  { label: "Beranda", href: "#beranda" },
  { label: "Produk", href: "#produk" },
  { label: "Manfaat", href: "#manfaat" },
  { label: "Tentang", href: "#tentang" },
  { label: "Kontak", href: "#kontak" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-black/5 shadow-[0_1px_0_rgba(0,0,0,0.03)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#beranda"
          data-testid="nav-logo"
          className="flex items-center gap-3 font-serif-display text-2xl md:text-3xl tracking-[0.15em] text-[#1A1A1A] font-medium"
        >
          <img
            src="/brand/davm-logo.png"
            alt="DA'VM"
            className="h-9 md:h-11 w-auto"
          />
          <span>DA&apos;VM</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="link-underline text-sm tracking-wide text-[#1A1A1A]/80 hover:text-[#1A1A1A] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            asChild
            data-testid="nav-member-area-button"
            className="hidden sm:inline-flex rounded-full bg-[#1A1A1A] hover:bg-[#BCA38F] text-[#FDFBF7] px-5 h-11 text-xs tracking-[0.18em] uppercase transition-all duration-500 group"
          >
            <a href={memberAreaUrl()} onClick={() => trackMemberAreaClick("navbar_desktop")}>
              Member Area
              <ArrowUpRight className="ml-2 h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Button>

          <button
            className="md:hidden p-2 text-[#1A1A1A]"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-black/5"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                className="text-base tracking-wide text-[#1A1A1A]/80 hover:text-[#1A1A1A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={memberAreaUrl()}
              onClick={() => trackMemberAreaClick("navbar_mobile")}
              data-testid="nav-mobile-member-area"
              className="inline-flex items-center justify-center rounded-full bg-[#1A1A1A] text-[#FDFBF7] px-5 h-11 text-xs tracking-[0.18em] uppercase"
            >
              Member Area
              <ArrowUpRight className="ml-2 h-4 w-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
